import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { CONSTANT } from "../../utils/Constants";

interface MessageTypes {
  type: number;
  msg: string;
  details?: string;
  callback?: () => void;
}

const MessageManager = ({ type, msg, details, callback }: MessageTypes) => {
  useEffect(() => {
    showMessage();
    // eslint-disable-next-line
  }, []);

  const { t } = useTranslation();

  const showMessage = () => {
    Swal.fire({
      title: `<span style="font-weight: 400">${msg}</span>`,
      text: details,
      icon: type === CONSTANT.ERROR_MSG ? "error" : "success",
      confirmButtonText: t("ok"),
      confirmButtonColor: "#0A3A7A",
      customClass: {
        confirmButton: "primaryButton",
        cancelButton: "btn btn-danger",
      },
    }).then(() => callback && callback());
  };

  return <></>;
};

export default MessageManager;
